module.exports = __webpack_public_path__ + "img/shed-logo-1440.c20e5acf.jpg";